import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

export const PhoneMockup = () => {
  return (
    <div className="relative mx-auto w-[280px] h-[580px] bg-ink rounded-[45px] border-[8px] border-gray-800 shadow-2xl overflow-hidden flex flex-col">
      {/* Notch */}
      <div className="absolute top-0 inset-x-0 h-6 flex justify-center z-20">
        <div className="w-32 h-6 bg-gray-800 rounded-b-2xl"></div>
      </div>

      {/* Screen Content */}
      <div className="flex-1 bg-paper flex flex-col pt-12 pb-6 px-5 relative z-10">
        <header className="mb-6 flex justify-between items-center">
          <div>
            <p className="text-xs text-gray-500 font-medium tracking-wide">TODAY</p>
            <h3 className="text-xl font-semibold text-ink">Overview</h3>
          </div>
          <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center">
            <SafeIcon name="User" className="text-gray-400" />
          </div>
        </header>

        {/* Progress Card */}
        <div className="bg-white rounded-2xl p-4 shadow-soft mb-4">
          <div className="flex justify-between items-center mb-3">
            <span className="text-sm font-medium text-gray-600">Next Dose</span>
            <span className="text-xs font-bold text-mint bg-mint/10 px-2 py-1 rounded-full">Tomorrow</span>
          </div>
          <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full bg-wave-gradient w-5/6 rounded-full"></div>
          </div>
          <div className="mt-3 flex justify-between items-end">
            <div>
              <p className="text-2xl font-semibold text-ink">0.5<span className="text-sm text-gray-400 font-normal ml-1">mg</span></p>
            </div>
            <div className="h-8 w-8 rounded-full bg-ink flex items-center justify-center">
              <SafeIcon name="Check" className="text-white" />
            </div>
          </div>
        </div>

        {/* Chart Mockup */}
        <div className="bg-white rounded-2xl p-4 shadow-soft flex-1">
          <div className="flex justify-between items-center mb-4">
            <span className="text-sm font-medium text-gray-600">Weight Trend</span>
            <SafeIcon name="TrendingUp" className="text-gray-400" />
          </div>
          <div className="relative h-32 w-full flex items-end gap-2">
            {/* Fake bars */}
            {[40, 55, 45, 60, 75, 65, 80].map((h, i) => (
              <motion.div 
                key={i}
                initial={{ height: 0 }}
                animate={{ height: `${h}%` }}
                transition={{ duration: 1, delay: 0.5 + (i * 0.1) }}
                className={`flex-1 rounded-t-md ${i === 6 ? 'bg-sky' : 'bg-gray-100'}`}
              ></motion.div>
            ))}
          </div>
        </div>
        
        {/* Bottom Nav Mockup */}
        <div className="mt-4 flex justify-between px-2">
          {['Home', 'Calendar', 'PlusCircle', 'Activity', 'Settings'].map((icon, i) => (
            <SafeIcon 
              key={i} 
              name={icon} 
              className={`text-xl ${i === 0 ? 'text-ink' : i === 2 ? 'text-mint text-3xl -mt-2' : 'text-gray-300'}`} 
            />
          ))}
        </div>
      </div>
    </div>
  );
};